"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* *
 *  H5隐藏APP分享按钮
 *
 */
var hideShare = [{
  pattern: {
    "IOS|FINO": ["gte", "1.0.9"],
    "ANDROID|FINO": ["gte", "1.1.0"]
  },
  handler: function handler(option) {
    return this.invoke(109, {
      businessId: 1
    });
  }
}, {
  pattern: {
    "IOS|FINO": ["gte", "1.0.0"],
    "ANDROID|FINO": ["gte", "1.0.0"]
  },
  handler: function handler(option) {
    return this.invoke(109, {
      businessId: 1
    });
  }
}];

exports.default = {
  hideShare: hideShare
};